export default __webpack_public_path__ + "fonts/4cb75e0804b70e0e353cfca7cd76c9b3.ttf";